export default class HeroHeading {
    constructor({ el }) {
        this.element = el;

        // Initialize the functionality
        this.init();
    }

    init() {
        if (this.element) {
            // Get the text content of this.element
            const text = this.element.textContent;

            // Run the text through the wrapWords function with transition delay logic
            const wrappedTextWithDelay = this.addTransitionDelay(text);

            // Set the modified content back to this.element
            this.element.innerHTML = wrappedTextWithDelay;
        }
    }
    
    addTransitionDelay(text) {
        // Split the text into words, remove empty strings, wrap each word in a span, and add a progressive transition delay
        return text
            .split(/\s+/)                      // Split the text into words
            .filter(word => word !== "")        // Filter out any empty words (caused by leading/trailing spaces)
            .map((word, index) => {
                return `<span style="transition: opacity 1s, transform 1s; transition-delay: ${(index + 1) * 200}ms;">${word}</span>`;
            })
            .join(' ');                         // Join the words back with a space
    }
}
